import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";

export const save = ({ uuid, courtUuid, title, appointmentDate, termStart, termEnd, chambersAddressUuid, ChambersAddress, chambersPhone, chambersFax, meta }) => async (dispatch) => {
    try {
        const res = await api.post(`/judges`, { uuid, courtUuid, title, appointmentDate, termStart, termEnd, chambersAddressUuid, ChambersAddress, chambersPhone, chambersFax, meta });
        return res.data;
    } catch (error) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.delete(`/judges/i/${uuid}`) : { data: { success: false }} ;
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const get = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/judges/i/${uuid}`) : { data: { success: false }} ;
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}
